import { SagaIterator } from 'redux-saga';
import { PROJECT_EVENT_SEND } from 'src/modules/project-event/actions/ProjectEventActions';
import { projectEventSendSaga } from 'src/modules/project-event/sagas/projectEventSendSaga';
import { takeEvery } from 'typed-redux-saga';

export function* projectEventSaga(): SagaIterator<void> {
  yield* takeEvery(PROJECT_EVENT_SEND.is, projectEventSendSaga);
}
